<script setup>
  import ComponentAccordion from "@components/Accordion/Accordion.vue";
  import ComponentAccordionItem from "@components/Accordion/AccordionItem.vue";
  import ComponentAlert from "@components/Alerts/Alert.vue";
  import PatientinputComponentStep from "@pages/Patientinput/Components/Step.vue";
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PatientinputComponentStepSuccessPatient",
  });

  defineProps({
    form: {
      type: Object,
      required: true,
    },
  });
</script>

<template>
  <PatientinputComponentStep title="Vielen Dank!" :back-button="false" :forward-button="false" :test-id="getTestId()">
    <ComponentAlert type="succes" :test-id="getTestId('success-patient-step')">
      Ihre Angaben wurden erfolgreich übermittelt. Sie können dieses Fenster nun schließen.
    </ComponentAlert>

    <section>
      <h2 class="mb-3 text-xl font-bold">Was passiert als Nächstes?</h2>

      <ComponentAccordion>
        <ComponentAccordionItem init-opened :test-id="getTestId('success-patient-step-initial-consultation')">
          <template #title><h3>Erstgespräch</h3></template>
          <template #icon>
            <div class="flex aspect-square h-10 items-center justify-center rounded-full border-1 border-mcred">
              <img src="@assets/icons/pill.svg" alt="" class="h-10" />
            </div>
          </template>

          <div class="flex flex-col gap-3">
            <p>Bitte vereinbaren Sie für unser erstes Gespräch einen Termin, falls nicht schon geschehen.</p>

            <p>
              Bitte bringen Sie zum Termin alle Medikamente (verordnet, rezeptfrei, pflanzlich, äußerlich anzuwendend,
              Vitamine, Mineralstoffe, Nahrungsergänzungsmittel etc.) mit. Kühlpflichtige Medikamente lassen Sie bitte
              zuhause und notieren einfach den Namen, die Wirkstärke und bis wann das Medikament verwendbar ist.
            </p>

            <p>
              Mehr Informationen und eine praktische Informationsbroschüre können Sie unten per Klick herunterladen.
            </p>

            <MedButton
              as="a"
              variant="primary"
              href="https://medicheck.pharma4u.de/url-redirect/medicheck-patient-flyer"
              target="_blank"
              :data-test="getTestId('success-patient-step-initial-consultation-accordion-item-patient-flyer-button')"
            >
              Informationsbroschüre herunterladen
            </MedButton>
          </div>
        </ComponentAccordionItem>

        <ComponentAccordionItem :test-id="getTestId('success-patient-step-review')">
          <template #title><h3>Überprüfung</h3></template>
          <template #icon>
            <div class="flex aspect-square h-10 items-center justify-center rounded-full border-1 border-mcred">
              <img src="@assets/icons/pharmacist.svg" alt="" class="h-10" />
            </div>
          </template>

          Wir überprüfen nach dem Erstgespräch sorgfältig alle Ihre Medikamente auf mögliche Risiken. Falls relevante
          Probleme erkannt werden, können wir diese auf Ihren Wunsch hin mit Ihrem Arzt / Ihrer Ärztin besprechen, um
          gemeinsam eine gute Lösung zu finden.
        </ComponentAccordionItem>

        <ComponentAccordionItem :test-id="getTestId('success-patient-step-initial-final-discussion')">
          <template #title><h3>Abschlussgespräch</h3></template>
          <template #icon>
            <div class="flex aspect-square h-10 items-center justify-center rounded-full border-1 border-mcred">
              <img src="@assets/icons/diagnosis.svg" alt="" class="h-10" />
            </div>
          </template>

          Im zweiten Gespräch besprechen wir gemeinsam mit Ihnen in aller Ruhe alle Medikamente und deren richtige
          Anwendung. Wir nehmen uns gern Zeit, Ihre Fragen zu beantworten. Sie erhalten einen aktuellen Medikationsplan
          und wertvolle Empfehlungen für Ihre Gesundheit.
        </ComponentAccordionItem>
      </ComponentAccordion>
    </section>
  </PatientinputComponentStep>
</template>
